export default __webpack_public_path__ + "static/media/cnc-machining.4e6d299c.png";